module.exports = __webpack_public_path__ + "img/bell.03630ecd.svg";